var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",attrs:{"settingLayout":_vm.settingLayout}})}
var staticRenderFns = []

export { render, staticRenderFns }